export default __webpack_public_path__ + "static/section_5_details_1-61239ec0a11434c3651fcb53ee1b9483.png";